import _ from "lodash";
import React, { Component } from "react";
import classNames from "classnames";
import { Scrollbars } from "react-custom-scrollbars";
import * as mediator from "@tvg/mediator-classic/src";
import RaceFilter from "@tvg/race-filter/src/pages/RaceFilter";
import ListIcon from "@tvg/ui-bootstrap/assets/svg/list.svg";
import LiveVideo from "@tvg/ui-bootstrap/assets/svg/live-video.svg";
import style from "./style.css";

class TabsSystem extends Component {
  constructor() {
    super();
    _.bindAll(this, [
      "tabsHeader",
      "tab",
      "tabsContent",
      "toggleScroll",
      "selectTab"
    ]);
  }

  state = {
    selectTab: 0,
    scrollDisabled: false
  };

  componentDidMount() {
    mediator.subscribe("LHN_SCROLL_DISABLE", this.toggleScroll);
  }

  componentWillUnmount() {
    mediator.unsubscribe("LHN_SCROLL_DISABLE", this.toggleScroll);
  }

  selectTab(index) {
    return () => {
      // Gtm Event
      mediator.dispatch("LHN_TAB_SELECT", {
        type: _.get(this.props, `headerColumns[${index}]`)
      });
      return this.setState({ selectTab: index });
    };
  }

  tabsHeader() {
    const { headerColumns, tabs } = this.props;

    const headerLabels = headerColumns.map((label, index) => {
      const icon =
        label.toLowerCase().replace(" ", "") !== "livevideo" ? (
          <ListIcon width="16" height="16" />
        ) : (
          <LiveVideo width="16" height="16" />
        );
      const activeTab = this.state.selectTab === index ? style.activeTab : "";
      return (
        <li
          // eslint-disable-next-line react/no-array-index-key
          key={`tabHeader${index}`}
          className={classNames(style.tab, activeTab)}
        >
          <button
            type="button"
            className={style.selectTab}
            disabled={_.get(tabs, `[${index}].props.disableTab`)}
            onClick={this.selectTab(index)}
          >
            <div className={style.buttonFlexWrapper}>
              <span className={style.tabIcon}>{icon}</span>
              <span className={style.tabLabel}>{label}</span>
            </div>
          </button>
        </li>
      );
    });

    return (
      <ul id="tabsWrapperHeader" className={style.tabsWrapper}>
        {headerLabels}
      </ul>
    );
  }

  tab(content, index) {
    const showTab = index === this.state.selectTab ? style.tabShow : "";
    return (
      <li
        key={`tabContent${index}`}
        className={classNames(style.tabContent, showTab)}
      >
        {content}
      </li>
    );
  }

  tabsContent() {
    const { tabs } = this.props;
    return (
      <Scrollbars
        className={classNames(
          style.scrollBar,
          this.state.scrollDisabled ? style.scrollBarDisabled : ""
        )}
        autoHide
        autoHideTimeout={1000}
        universal
      >
        <ul className={style.tabsContentWrapper}>{tabs.map(this.tab)}</ul>
      </Scrollbars>
    );
  }

  toggleScroll(data) {
    this.setState({ scrollDisabled: data.disableToggleValue || false });
  }

  props;

  render() {
    return (
      <div className={style.tabSystem}>
        {this.props.showLhnHeader && this.tabsHeader()}
        {this.props.withFilters && this.state.selectTab === 0 && (
          <RaceFilter context="lhn" />
        )}
        {this.tabsContent()}
      </div>
    );
  }
}
export default TabsSystem;
